'use client';

import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

interface MainContentWrapperProps {
  children: ReactNode;
}

export const MainContentWrapper = ({ children }: MainContentWrapperProps) => {
  const pathname = usePathname();
  const isAdminPage = pathname?.startsWith('/admin');
  const isProposalPage = pathname?.startsWith('/challenges/propose');
  const isPromotionsPage = pathname?.startsWith('/promotions');
  const isChallengesPage = pathname === '/challenges';
  const isMyPage = pathname === '/mypage';
  const isUgcEventPage = pathname?.startsWith('/events/ugcevent');
  // App Router route group (onboarding) renders as '/welcome/*'
  const isOnboarding = pathname?.startsWith('/welcome') || pathname?.startsWith('/onboarding');

  if (isProposalPage) {
    return <main className="h-full">{children}</main>;
  }

  // UGC Event 랜딩 페이지: 전체 화면, 여백/패딩 없이 렌더링
  if (isUgcEventPage) {
    return <main className="w-full">{children}</main>;
  }

  let mainClassName = 'pb-[58px] w-full';

  // 관리자 페이지: 이미 전체 폭 사용
  if (isAdminPage) {
    mainClassName = 'pb-[58px] w-full';
  } else {
    // 하위 페이지는 기존처럼 가운데 정렬 + 최대폭 제한
    mainClassName = 'pb-[58px] mx-auto w-full';
  }

  // Onboarding pages should follow project standard layout without bottom padding offset changes from BottomNav
  if (isOnboarding) {
    mainClassName = 'mx-auto w-full';
  }

  if (isChallengesPage || isMyPage) {
    mainClassName = 'pb-[58px] w-full';
  } else if (pathname?.startsWith('/challenges/')) {
    mainClassName = 'pb-[58px] mx-auto w-full';
  } else if (pathname === '/leaderboard') {
    mainClassName = 'pb-[58px] w-full';
  } else {
    mainClassName = 'mx-auto w-full';
  }

  // Promotions page should not have bottom padding
  if (isPromotionsPage) {
    mainClassName = 'mx-auto w-full';
  }

  return <main className={`${mainClassName} flex-grow`}>{children}</main>;
};
